import SmallCardPic from "../assets/ComponentPics/SmallCard.png";
import { Link } from "react-router-dom";
const SmallCard = () => {
  return (
    <div className="bg-[#00f6f6] rounded-2xl max-h-[300px] max-w-6xl mx-auto shadow-lg p-5 md:p-0" >
      <div className="grid grid-cols-1 md:grid-cols-2 items-center">
        {/* Text Section */}
        <div className="p-5 md:p-10">
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-3">
          Optimise Hiring, Automate Workflows.
          </h2>
          <p className="text-black mb-5">
          Unlock Talent and contact AIAURA today for a demo
          </p>
          <div className="flex gap-3">
           
            <button className="bg-[#18406e] text-white font-semibold px-4 py-2 rounded-md shadow-md transition duration-500 transition-transform transform hover:scale-105">
              <Link to="/contact">
              Contact Us
              </Link>
            </button>
          </div>
        </div>

        {/* Image Section */}
        <div className="relative h-full max-h-[300px]">
          <img
            src={SmallCardPic}
            alt="AI Illustration"
            className="hidden md:block md:h-full md:w-full md:object-cover md:rounded-r-2xl"
          />
          {/* Gradient Overlay */}
          <div className="absolute inset-0 rounded-r-2xl bg-gradient-to-l from-transparent to-[#00f6f6]/60"></div>
        </div>
      </div>
    </div>
  );
};

export default SmallCard;
